import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge bg-warning mb-1 pointer user-select-none",
  "data-bs-toggle": "modal",
  "data-bs-target": "#createTagModal"
}, "Create new tag", -1)
const _hoisted_2 = { class: "me-1" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tag = _resolveComponent("Tag")
  const _component_CreateTagModal = _resolveComponent("CreateTagModal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("a", {
      class: "btn btn-info",
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.collapse = !_ctx.collapse)),
      "data-bs-toggle": "button"
    }, "Add tags"),
    _createElementVNode("div", {
      class: _normalizeClass(["mt-2", {collapse: _ctx.collapse}])
    }, [
      _hoisted_1,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.allTicketTags, (tag) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.ticket.tags.some(o => o.name == tag.name))
            ? (_openBlock(), _createBlock(_component_Tag, {
                key: 0,
                class: "pointer",
                tag: tag,
                onClick: $event => (_ctx.add(tag))
              }, null, 8, ["tag", "onClick"]))
            : _createCommentVNode("", true)
        ]))
      }), 256)),
      _createVNode(_component_CreateTagModal, {
        "all-tags": _ctx.data?.allTicketTags,
        currentProduct: _ctx.ticket.product.id,
        onAddTag: _ctx.add
      }, null, 8, ["all-tags", "currentProduct", "onAddTag"])
    ], 2)
  ]))
}